import service from "./service";
import {getEndpoints} from "../helpers";

export const getAccountInfo = ()=>{
    return service.extGetAccess(getEndpoints.accountServiceUrl + "api/user/info/")
}